export default "__VITE_ASSET__BIIJuu64__"